module.exports = __webpack_public_path__ + "static/media/previewlifestyle1-large.5ae70fe4.jpg";